export const INVOICE = 'Invoice';
export const InvoiceDirectionValues = ['IN', 'OUT'];
export const InvoiceIssuerKindValues = ['OWN', 'THIRD_PARTY'];
export const InvoiceStatusValues = [
    'draft',
    'authorized',
    'cancelled',
];
export const INVOICE_STATUS_LABELS = {
    draft: 'Rascunho',
    authorized: 'Autorizada',
    cancelled: 'Cancelada',
};
export const InvoiceReceivingCheckValues = [
    'none',
    'requested',
    'checked',
];
export const INVOICE_RECEIVING_CHECK_LABELS = {
    none: 'Não solicitada',
    requested: 'Conferência solicitada',
    checked: 'Conferida',
};
//# sourceMappingURL=invoice.js.map